<details class="group [&_summary::-webkit-details-marker]:hidden" [open]="open">
  <summary
    class="flex cursor-pointer items-center justify-between rounded-lg text-[#222] leading-[2rem] font-[500] mb-1"
  >
    <span class="">{{ title }}</span>

    <span class="shrink-0 transition duration-300 group-open:-rotate-180">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="size-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </span>
  </summary>

  <ng-content></ng-content>
</details>
